import DialPadModal from './DialPadModal.vue';

export default DialPadModal;
